import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { fetchLastRequest } from '../../../api/services/ContactsService';
import SimpleModal from '../../pages/contacts/SimpleModal';
import {
  Breakpoint,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';

const BaseRequestModal: React.FC<
  React.PropsWithChildren<{
    show: boolean;
    setModal: (open: boolean) => void;
    title: string;
    modalSize?: Breakpoint;
    onSubmitRequest: () => void;
    requestType: string;
    setLastRequest: (lastRequest: any) => void;
    loadLastRequest: () => void;
    closeVisible: boolean;
    setCloseVisible: (closeVisible: boolean) => void;
    className?: string;
    submitting: boolean;
  }>
> = ({
  children,
  show,
  setModal,
  title,
  modalSize,
  //TODO: this is not used below with a comment that it doesnt work when adding this
  //lets either remove it or fix
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onSubmitRequest,
  requestType,
  setLastRequest,
  loadLastRequest,
  closeVisible,
  setCloseVisible,
  className,
  submitting,
  ...rest
}) => {
  const i18n = useTranslation();

  const getLastRequest = useCallback(() => {
    fetchLastRequest(
      requestType,
      (res: any) => {
        const lastRequest = res?.data?.data?.sender;
        setLastRequest(lastRequest);
      },
      () => {}
    );
  }, [requestType, setLastRequest]);
  useEffect(() => {
    getLastRequest();
  }, [getLastRequest]);

  return (
    <>
      <Dialog
        className={className}
        open={show}
        onClose={() => setModal(false)}
        maxWidth={modalSize ? modalSize : 'md'}
        aria-labelledby="contained-modal-title-vcenter"
        {...rest}
      >
        <DialogTitle>{title}</DialogTitle>

        <DialogContent>{children}</DialogContent>

        <DialogActions>
          <Button onClick={() => setModal(false)}>Cancel</Button>

          <form>
            <Button
              type="submit"
              variant="contained"
              data-testId="request-submit"
              disabled={submitting}
              // onClick={() => onSubmitRequest()} // if we add this, the forms are not sent anymore 🤔
            >
              Request
            </Button>
          </form>
        </DialogActions>
      </Dialog>
      {requestType && (
        <SimpleModal
          header={i18n.t('contactCenter.detail.manage_request.prefill_request')}
          contact={null}
          request_action="Close"
          title={
            <DialogContentText className="m-0 p-0 ">
              {i18n.t(
                'contactCenter.detail.manage_request.prefill_confirmation'
              )}{' '}
              {requestType.toLowerCase()} request form?
            </DialogContentText>
          }
          confirm={'Yes'}
          cancel={i18n.t('contactCenter.detail.manage_request.cancel')}
          state={closeVisible}
          onClose={() => {
            setCloseVisible(false);
          }}
          onSave={() => {
            loadLastRequest();
            setCloseVisible(false);
          }}
        />
      )}
    </>
  );
};

export default BaseRequestModal;
